// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.master-view-search-wrapper {
  justify-content: flex-start !important;
}

.master-view-batch-table .rdt_TableHead {
  width: 150%;
}
.master-view-batch-table .bMgaAx div:first-child {
  width: 150%;
  white-space: normal;
}
.master-view-batch-table .rdt_TableBody {
  width: 150%;
  align-items: center;
}

.circle {
  display: inline-block;
  width: 15px;
  height: 15px;
  border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./src/views/pages/invoices-error/style.scss"],"names":[],"mappings":"AAAA;EACE,sCAAA;AACF;;AAGE;EACI,WAAA;AAAN;AAGE;EACI,WAAA;EACA,mBAAA;AADN;AAIE;EACI,WAAA;EACA,mBAAA;AAFN;;AAMA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAHF","sourcesContent":[".master-view-search-wrapper{\r\n  justify-content: flex-start !important;\r\n}\r\n\r\n.master-view-batch-table{\r\n  .rdt_TableHead {\r\n      width: 150%;\r\n  }\r\n\r\n  .bMgaAx div:first-child {\r\n      width: 150%;\r\n      white-space: normal;\r\n  }\r\n\r\n  .rdt_TableBody{\r\n      width: 150%;\r\n      align-items: center;\r\n  }\r\n}\r\n\r\n.circle {\r\n  display: inline-block;\r\n  width: 15px;\r\n  height: 15px;\r\n  border-radius: 50%;\r\n  // background-color: #00FF00;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
